export default __webpack_public_path__ + "static/solution-of-a-self-testing-fe1d10b114e461fe05ac8e327372b9d0.jpg";